export default __webpack_public_path__ + "static/media/raspberry-pi.0bd92cb0.svg";